import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { routes } from '@model/constants/routes';
import { getHttpHeaders } from '@commons/utility/util';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private readonly headers = getHttpHeaders();
  private readonly subject = new Subject();
  private readonly apiUrl: string;

  constructor(private readonly http: HttpClient) {
    this.apiUrl = environment.apiUrl;
  }

  public getUserInformation(): any {
    return this.http.get<any>(this.apiUrl + routes.getUserInformation, { headers: this.headers });
  }

  public showMenu(state: boolean = true) {
    this.subject.next({
      showMenu: state,
    });
  }

  public updateUserInfo() {
    this.subject.next({
      updateUserInfo: true,
    });
  }

  public getMenuControl(): Observable<any> {
    return this.subject.asObservable();
  }
}
